import { createMuiTheme } from "@material-ui/core/styles";

export const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#ff1744",
      light: "#ff8098",
    },
    secondary: {
      main: "#1c1c1c",
      contrastText: "#ffcc00",
    },
    contrastThreshold: 3,
    tonalOffset: 0.2,
  },
  typography: {
    fontFamily: "Roboto, sans-serif",
    h1: {
      fontSize: 32,
      fontWeight: 600,
    },
    h2: {
      fontSize: 26,
      fontWeight: 600,
    },
    h3: {
      fontSize: 24,
    },
    h4: {
      fontSize: 22,
    },
    h5: {
      fontSize: 20,
      fontWeight: 600,
    },
    h6: {
      fontSize: 17,
    },
    p: {
      fontSize: "1rem",
      fontWeight: 400,
    },
    body1: {
      fontSize: "1rem",
      fontWeight: 400,
    },
    body2: {
      fontSize: ".9rem",
      fontWeight: 400,
    },
    button: {
      fontSize: "16px",
      fontWeight: 600,
    },
  },
  overrides: {
    MuiCssBaseline: {
      "@global": {
        "@font-face": "Roboto",
      },
    },
    MuiInputBase: {
      root: {
        width: "100%",
      },
    },
    MuiListItemIcon: {
      root: {
        minWidth: "auto",
      },
    },
    MuiContainer: {
      root: {
        margin: "0px",
        padding: "0px",
      },
      maxWidthLg: {
        maxWidth: "1680px !important",
      },
    },
    MuiTab: {
      root: {
        maxWidth: "90%",
        fontWeight: 400,
      },
      wrapper: {
        flexDirection: "row",
        justifyContent: "flex-start",
        fontSize: ".95rem",
      },
    },
    MuiFab: {
      root: {
        background: "#ff1744",
      },
      primary: {
        background: "#ff1744",
        fontSize: "14px",
      },
    },
    MuiFormControlLabel: {
      root: {
        marginTop: 0,
      },
    },
    MuiPaper: {
      elevation1: {
        boxShadow: "0 8px 20px rgba(200,200,200,0.5);",
      },
    },
    MuiSelect: {
      root: {
        width: "90%",
      },
    },
    MuiDrawer: {
      root: {
        top: 60,
        zIndex: 0,
      },
    },
    MuiBackdrop: {
      root: {
        top: 60,
        zIndex: 0,
      },
    },
  },
  contrastThreshold: 3,
  tonalOffset: 0.2,
});
